@if (remindersList.length && remindersPopupEnabled) {
  <div
    class="reminderAlerts"
    data-test="reminderPopup"
    >
    <div class="remindersList">
      @for (
        reminder of remindersList; track remindersTrackBy($index,
        reminder); let first = $first; let last = $last) {
        <ng-content
          >
          <pp-reminder-alert
            [ppHighlighted]="reminder.reminderId === highlightedReminder.reminderId"
            [ppReminder]="reminder"
            (ppSelect)="selectReminder(reminder)"
          ></pp-reminder-alert>
          @if (!last) {
            <div class="reminderSeparator">
              <div class="reminderSeparator__line"></div>
            </div>
          }
        </ng-content>
      }
    </div>
    <div class="reminderButtons">
      <pp-reminder-snooze-button
        [ppReminders]="remindersList"
        [ppReminder]="highlightedReminder"
      ></pp-reminder-snooze-button>
      <pp-reminder-dismiss-button
        [ppReminders]="remindersList"
        [ppReminder]="highlightedReminder"
      ></pp-reminder-dismiss-button>
    </div>
  </div>
}
